export const buildTaskDescription = (jobForm) => {
    const sections = [jobForm.summary.trim()];
    if (jobForm.category.trim())
        sections.push(`Category: ${jobForm.category.trim()}`);

    const skills = jobForm.skills
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    if (skills.length) sections.push(`Skills: ${skills.join(', ')}`);

    const acceptanceCriteria = jobForm.acceptanceCriteria
        .split('\n')
        .map((item) => item.trim())
        .filter(Boolean);
    if (acceptanceCriteria.length) {
        sections.push(
            `Acceptance Criteria:\n${acceptanceCriteria.map((item) => `- ${item}`).join('\n')}`,
        );
    }

    return sections.filter(Boolean).join('\n\n');
};

export const parseTaskDescription = (description = '') => {
    const sections = String(description || '')
        .split('\n\n')
        .map((section) => section.trim())
        .filter(Boolean);

    const parsed = {
        summary: '',
        category: '',
        skills: [],
        acceptanceCriteria: [],
    };

    sections.forEach((section) => {
        if (section.startsWith('Category:')) {
            parsed.category = section.replace('Category:', '').trim();
            return;
        }
        if (section.startsWith('Skills:')) {
            parsed.skills = section
                .replace('Skills:', '')
                .split(',')
                .map((item) => item.trim())
                .filter(Boolean);
            return;
        }
        if (section.startsWith('Acceptance Criteria:')) {
            parsed.acceptanceCriteria = section
                .replace('Acceptance Criteria:', '')
                .split('\n')
                .map((item) => item.replace(/^-/, '').trim())
                .filter(Boolean);
            return;
        }
        if (!parsed.summary) {
            parsed.summary = section;
        }
    });

    if (!parsed.summary && sections.length) {
        parsed.summary = sections[0];
    }

    return parsed;
};
